/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

// require('./bootstrap');

$(document).ready(function () {
    $.fn.successModal = function ($type) {
        if( $type === 'donate') {
            $('#donate-label-finish').text('Thank You');
            $('#donate-body').html('<p class="modal__desc">Transfer to Bulir Padi Foundation account:</p>\n' +
                '            <p class="modal__desc">Yayasan Bulir Padi<br>\n' +
                '              CIMB Niaga cabang Gatot Subroto<br>\n' +
                '              Jakarta<br>\n' +
                '              No. 8001.2471.5700\n' +
                '            </p>\n' +
                '            <p class="modal__desc">Thank you for your generosity in supporting our worthy cause and we look forward to hearing from you!</p>');
        }

        if($type === 'volunteer') {
            $('#volunteer-label-finish').text('Thank You');
            $('#volunteer-body').html('<p class="modal__desc">Thank you for your generosity in supporting our worthy cause and we look forward to hearing from you!</p>');
        }

        if($type === 'partnership') {
            $('#partnership-label-finish').text('Thank You');
            $('#partnership-body').html('<p class="modal__desc">One of our staff will contact you soon.</p>');
        }
    };

    $.fn.errorModal = function (errorCode) {
        $('#donate-label-finish').text('Error has occurred');
        $('#donate-body').html('<p class="modal__desc" style="text-align: center">Ops! Something went wrong, please try again. Error code: '+errorCode+'+</p>');
    };

    $.fn.resetDonateForm = function () {
        document.getElementById('form-donate').reset();

        $(".dropdown-gender .btn:first-child").text('Gender');
        $(".dropdown-gender .btn:first-child").val('');
        $(".dropdown-programs .btn:first-child").text('Programs');
        $(".dropdown-programs .btn:first-child").val('');
        $(".dropdown-payment .btn:first-child").text('Payment');
        $(".dropdown-payment .btn:first-child").val('');
    };

    $.fn.resetVolunteerForm = function () {
        document.getElementById('form-volunteer').reset();

        $(".dropdown-age .btn:first-child").text('Age Group');
        $(".dropdown-age .btn:first-child").val('');

        $(".dropdown-position .btn:first-child").text('Position');
        $(".dropdown-position .btn:first-child").val('');
        $(".dropdown-position .textbox").hide();

        $(".dropdown-experience .btn:first-child").text('Experience');
        $(".dropdown-experience .btn:first-child").val('');
        $(".dropdown-experience .textbox").hide();

        $(".dropdown-source .btn:first-child").text('Source');
        $(".dropdown-source .btn:first-child").val('');
        $(".dropdown-source .textbox").hide();
    };

    $.fn.resetPartnershipForm = function () {
        document.getElementById('form-partnership').reset();

        $(".dropdown-business .btn:first-child").text('Business');
        $(".dropdown-business .btn:first-child").val('');
        $(".dropdown-business .textbox").hide();

        $(".dropdown-department .btn:first-child").text('Department');
        $(".dropdown-department .btn:first-child").val('');
        $(".dropdown-department .textbox").hide();

        $(".dropdown-hours .btn:first-child").text('Work Type');
        $(".dropdown-hours .btn:first-child").val('');
        $(".dropdown-hours .textbox").hide();

        $(".dropdown-duration .btn:first-child").text('Duration');
        $(".dropdown-duration .btn:first-child").val('');

        $(".dropdown-source .btn:first-child").text('Source');
        $(".dropdown-source .btn:first-child").val('');
        $(".dropdown-source .textbox").hide();
    };

    $('.navbar-dropdown').on('show.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    $('.navbar-dropdown').on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });

    $(".home-carousel").owlCarousel({
        items: 1,
        nav: false,
        dots: true,
        dotsContainer: '.carousel-custom-dots',
        autoplay: true,
        autoplaySpeed: 800,
        loop: true
    });

    $('.owl-dot').click(function () {
        owl.trigger('to.owl.carousel', [$(this).index(), 300]);
    });

    $('.sidebar-slider').slick({
        dots: false,
        vertical: true,
        slidesToShow: 8,
        slidesToScroll: 8,
        verticalSwiping: true,
        infinite: false,
        prevArrow: '<i class="slick-prev arrow up"></i>',
        nextArrow: '<i class="slick-next arrow down"></i>',
        responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            }
        ]
    });

    $('a[data-slide]').click(function(e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        $('.slider-nav').slick('slickGoTo', slideno - 1);
    });

    $(".smooth-scroll").on('click', function (event) {
        if ($(this.hash).length > 0 && this.hash !== "") {
            event.preventDefault();
            var hash = this.hash;
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 1000)
        }
    });

    $(window).scroll(function() {
        var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
        if ($(this).scrollTop() > 200 && scrollBottom > 200) {
            $('#toTopButton').addClass('show');
        } else {
            $('#toTopButton').removeClass('show');
        }
    });

    $(".dropdown-gender .dropdown-menu .option").click(function () {
        $(".dropdown-gender .btn:first-child").text($(this).text());
        $(".dropdown-gender .btn:first-child").val($(this).data('value'));
    });

    $(".dropdown-programs .dropdown-menu .option").click(function () {
        $(".dropdown-programs .btn:first-child").text($(this).text());
        $(".dropdown-programs .btn:first-child").val($(this).data('value'));
    });

    $(".dropdown-payment .dropdown-menu .option").click(function () {
        $(".dropdown-payment .btn:first-child").text($(this).text());
        $(".dropdown-payment .btn:first-child").val($(this).data('value'));
    });

    $(".dropdown-age .dropdown-menu .option").click(function () {
        $(".dropdown-age .btn:first-child").text($(this).text());
        $(".dropdown-age .btn:first-child").val($(this).data('value'));
    });

    $(".dropdown-experience .dropdown-menu .option").click(function () {
        $(".dropdown-experience .btn:first-child").text($(this).text());
        $(".dropdown-experience .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Yes') {
            $(".dropdown-experience .textbox").show();
        } else {
            $(".dropdown-experience .textbox").hide();
        }
    });

    $(".dropdown-position .dropdown-menu .option").click(function () {
        $(".dropdown-position .btn:first-child").text($(this).text());
        $(".dropdown-position .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-position .textbox").show();
        } else {
            $(".dropdown-position .textbox").hide();
        }
    });

    $(".dropdown-source .dropdown-menu .option").click(function () {
        $(".dropdown-source .btn:first-child").text($(this).text());
        $(".dropdown-source .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-source .textbox").show();
        } else {
            $(".dropdown-source .textbox").hide();
        }
    });

    $(".dropdown-business .dropdown-menu .option").click(function () {
        $(".dropdown-business .btn:first-child").text($(this).text());
        $(".dropdown-business .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-business .textbox").show();
        } else {
            $(".dropdown-business .textbox").hide();
        }
    });

    $(".dropdown-department .dropdown-menu .option").click(function () {
        $(".dropdown-department .btn:first-child").text($(this).text());
        $(".dropdown-department .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-department .textbox").show();
        } else {
            $(".dropdown-department .textbox").hide();
        }
    });

    $(".dropdown-hours .dropdown-menu .option").click(function () {
        $(".dropdown-hours .btn:first-child").text($(this).text());
        $(".dropdown-hours .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-hours .textbox").show();
        } else {
            $(".dropdown-hours .textbox").hide();
        }
    });

    $(".dropdown-duration .dropdown-menu .option").click(function () {
        $(".dropdown-duration .btn:first-child").text($(this).text());
        $(".dropdown-duration .btn:first-child").val($(this).data('value'));

        if ($(this).data('value') === 'other') {
            $(".dropdown-duration .textbox").show();
        } else {
            $(".dropdown-duration .textbox").hide();
        }
    });

    $(".dropdown-source .dropdown-menu .option").click(function () {
        $(".dropdown-source .btn:first-child").text($(this).text());
        $(".dropdown-source .btn:first-child").val($(this).data('value'));

        if ($(this).text() === 'Other') {
            $(".dropdown-source .textbox").show();
        } else {
            $(".dropdown-source .textbox").hide();
        }
    });

    $(".press__wrapper-image").click(function () {
        $title = $(this).find('.title').text();
        $image = $(this).find('.press__image').attr('src');

        $('#press-modal #press-title').text($title);
        $('#press-modal #press-image').attr('src', $image);

        $('#press-modal').modal();
    });

    $('#form-donate').submit(function (e) {
        e.preventDefault();
        const url = '/donate';
        let values = {};
        let gender = $('#gender').val();
        let program = $('#program').val();
        let payment = $('#payment').val();

        $.each($('#form-donate').serializeArray(), function (i, field) {
            values[field.name] = field.value
        });

        values['gender'] = gender;
        values['program'] = program;
        values['payment'] = payment;

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: url,
            data: values,
            beforeSend: function(){
                $('#donate-modal').modal('hide');
                $('#loading-modal').modal('show');
            },
            complete: function(){
                $('#loading-modal').modal('hide');
            },
            success: function (data) {
                if(data.status === '201') {
                    $.fn.successModal('donate');
                } else{
                    $.fn.errorModal(data.status);
                }
                $('#donate-finish-modal').modal('show');
                $.fn.resetDonateForm();
            }
        })
    });

    $('#donate-modal').on('hidden.bs.modal', function () {
        $.fn.resetDonateForm();
    });

    $('#form-volunteer').submit(function (e) {
        e.preventDefault();

        const url = '/volunteer';
        let values = {};
        let age = $('#age').val();
        let experience = $('#experience').val();
        let position = $('#position').val();
        let source = $('#source').val();

        $.each($('#form-volunteer').serializeArray(), function (i, field) {
            values[field.name] = field.value
        });

        values['age'] = age;

        values['experience'] = '-';

        if(experience === 'yes' && experience.length > 0){
            values['experience'] = $('input[name="experience"]').val();
        }

        values['otherPosition'] = position;

        if(position === 'other') {
            values['otherPosition'] = $('input[name="otherPosition"]').val();
        }

        values['otherSource'] = source;

        if(source === 'other') {
            values['otherSource'] = $('input[name="otherSource"]').val();
        }

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: url,
            data: values,
            beforeSend: function(){
                $('#volunteer-modal').modal('hide');
                $('#loading-modal').modal('show');
            },
            complete: function(){
                $('#loading-modal').modal('hide');
            },
            success: function (data) {
                if(data.status === '201') {
                    $.fn.successModal('volunteer');
                } else{
                    $.fn.errorModal(data.status);
                }
                $('#volunteer-finish-modal').modal('show');
                $.fn.resetVolunteerForm();
            }
        })
    });

    $('#volunteer-modal').on('hidden.bs.modal', function () {
        $.fn.resetVolunteerForm();
    });

    $('#sidebarBtn').click(function () {
        var sidebar = $(this).closest('.sidebar');
        if (sidebar.hasClass('show')) {
            sidebar.removeClass('show');
            $('.overlay').removeClass('show');
        } else {
            $('.overlay').addClass('show');
            sidebar.addClass('show');
        }
    });

    $('#overlay').click(function () {
        var sidebar = $('.sidebar');
        if (sidebar.hasClass('show')) {
            sidebar.removeClass('show');
            $('.overlay').removeClass('show');
        }
    });

    $('#form-subscribe').submit(function (e) {
        e.preventDefault();
        let $email = $('input[name=newsletter]').val();
        let url = '/subscribe';

        if($email.length > 0) {
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                type: 'POST',
                url: url,
                data: {email: $email},
                beforeSend: function(){
                    $('#loading-modal').modal('show');
                },
                complete: function(){
                   $('#loading-modal').modal('hide');
                },
                success: function (data) {
                    if(data.status === '201') {
                        $('#subscribe-body').html('<p class="modal__desc">' + data.msg + '</p>');
                    } else{
                        $('h3#subscribe-label-finish').text('Oops!');
                        $('#subscribe-body').html('<p class="modal__desc">' + data.msg + '</p>');
                    }
                    $('#subscribe-finish-modal').modal('show');
                    $('input[name=newsletter]').val('');
                }
            })
        }
    });

    $('#form-partnership').submit(function (e) {
        e.preventDefault();

        const url = '/partnership';
        let values = {};
        let business = $('#business').val();
        let department = $('#department').val();
        let hours = $('#hours').val();
        let duration = $('#duration').val();
        let source = $('#source').val();

        $.each($('#form-partnership').serializeArray(), function (i, field) {
            values[field.name] = field.value
        });

        values['business'] = business;

        if(business === 'other') {
            values['business'] = $('input[name=business]').val();
        }

        values['department'] = department;

        if(department === 'other') {
            values['department'] = $('input[name=department]').val();
        }

        values['hours'] = hours;

        if(hours === 'other') {
            values['hours'] = $('input[name=hours]').val();
        }

        values['duration'] = duration;

        values['source'] = source;

        if(source === 'other') {
            values['source'] = $('input[name="source"]').val();
        }

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'POST',
            url: url,
            data: values,
            beforeSend: function(){
                $('#partnership-modal').modal('hide');
                $('#loading-modal').modal('show');
            },
            complete: function(){
                $('#loading-modal').modal('hide');
            },
            success: function (data) {
                if(data.status === '201') {
                    $.fn.successModal('partnership');
                } else{
                    $.fn.errorModal(data.status);
                }
                $('#partnership-finish-modal').modal('show');
                $.fn.resetPartnershipForm();
            }
        })
    });

    $('#partnership-modal').on('hidden.bs.modal', function () {
        $.fn.resetPartnershipForm();
    });

    var sync1 = $("#events-main-carousel");
    var sync2 = $("#events-nav-carousel");
    var slidesPerPage = 4;
    var syncedSecondary = true;

    sync1.owlCarousel({
        items : 1,
        smartSpeed: 1000,
        slideSpeed : 1000,
        nav: false,
        autoplay: true,
        dots: false,
        loop: true,
        mouseDrag: false,
        touchDrag: false,
        responsiveRefreshRate : 200,
    }).on('changed.owl.carousel', syncPosition);

    sync2
        .on('initialized.owl.carousel', function () {
          sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
        items : slidesPerPage,
        dots: false,
        nav: true,
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 2px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>','<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 2px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
        smartSpeed: 1000,
        slideSpeed : 1000,
        slideBy: slidesPerPage,
        responsiveRefreshRate : 1000,
        responsive: {
            0:{
              items: 3
            },
            768:{
              items: 4
            }
        }
    }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        var count = el.item.count-1;
        var current = Math.round(el.item.index - (el.item.count/2) - .5);

        if(current < 0) {
          current = count;
        }
        if(current > count) {
          current = 0;
        }

        sync2
          .find(".owl-item")
          .removeClass("current")
          .eq(current)
          .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
          sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
          sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if(syncedSecondary) {
          var number = el.item.index;
          sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function(e){
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/site.js